const lang = document.querySelector('.lang-container__current');
const mobileToggle = document.querySelector('.site-header__mobile__menu');
if (mobileToggle) {
  mobileToggle.addEventListener('click', () => {
    document.querySelector('.site-header__main-menu').classList.toggle('active');
    mobileToggle.classList.toggle('active');
    document.querySelector('body').classList.toggle('overflow--disable');
    if (lang) {
      document.querySelector('.site-header__lang-other').classList.remove('active');
      document.querySelector('.lang-container__current').classList.remove('active');
    }
  });
}

if (lang) {
  lang.addEventListener('click', () => {
    document.querySelector('.site-header__lang-other').classList.toggle('active');
    document.querySelector('.lang-container__current').classList.toggle('active');
  });
}
